export default "__VITE_ASSET__46e3d32b__"